import { render, staticRenderFns } from "./OperatingStatement.vue?vue&type=template&id=6a8fd910&scoped=true"
import script from "./OperatingStatement.vue?vue&type=script&lang=js"
export * from "./OperatingStatement.vue?vue&type=script&lang=js"
import style0 from "./OperatingStatement.vue?vue&type=style&index=0&id=6a8fd910&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8fd910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8fd910')) {
      api.createRecord('6a8fd910', component.options)
    } else {
      api.reload('6a8fd910', component.options)
    }
    module.hot.accept("./OperatingStatement.vue?vue&type=template&id=6a8fd910&scoped=true", function () {
      api.rerender('6a8fd910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/OperatingStatement.vue"
export default component.exports